import React, { Component } from "react";
import { HashLink } from "react-router-hash-link";
import Scrollspy from "react-scrollspy";
import Close from "../images/Close.svg";

export default class ArchiveMenu extends Component {
  render() {
    const { years, onClose, ...props } = this.props;
    return (
      <div
        className="ArchiveMenu bg-hugeorange text-white justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
        {...props}
      >
        <div className="absolute top-0 right-0 mt-3 mr-3">
          <img src={Close} alt="Close" onClick={() => onClose()} />
        </div>
        <div className="container relative">
          <div className="w-full h-full my-8 mx-auto text-center">
            <Scrollspy items={years} currentClassName="line-through">
              {years.map((year) => {
                return (
                  <div key={year} className="my-10">
                    <HashLink
                      smooth
                      to={"/Archive#" + year}
                      className="h2"
                      onClick={() => onClose()}
                    >
                      {year}
                    </HashLink>
                  </div>
                );
              })}
            </Scrollspy>
          </div>
        </div>
      </div>
    );
  }
}
